import { useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

import { GET_HOLDED_CONTACT_IDS } from '../../graphql/holded/query';
import type { ResponseDataHoldedList } from '../../types';
import { Error } from '../common/Error';
import { GenericDropdown } from './GenericDropdown';

type HoldedContactDropdownProps = {
  control: any;
  name: string;
  label?: string;
  placeholder?: string;
  error?: string;
  type?: 'andorra' | 'spain';
};

export const HoldedContactDropdown = ({
  control,
  name,
  label,
  placeholder,
  error,
  type,
}: HoldedContactDropdownProps) => {
  const [options, setOptions] =
    useState<{ value: string; label: string; image?: string }[]>();

  const [getHoldedContacts, { loading: loadingHoldedContacts }] =
    useLazyQuery<ResponseDataHoldedList>(GET_HOLDED_CONTACT_IDS);

  const getContacts = () => {
    getHoldedContacts({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      variables: { country: type || 'spain' },
      onCompleted: (data) => {
        setOptions(
          data.holdedContactIds.data
            .map((u) => ({
              label: `${u.name} ${u.email ? `(${u.email})` : ''}`,
              value: u.id,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)),
        );
      },
    });
  };

  useEffect(() => {
    if (!options) {
      getContacts();
    }
  }, [type]);

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row items-end gap-1">
        <GenericDropdown
          isClearable={true}
          control={control}
          name={name}
          label={label}
          isSearchable={true}
          options={options || []}
          isLoading={loadingHoldedContacts}
          placeholder={placeholder || label || ''}
        />
      </div>
      {error && <Error error={error} />}
    </div>
  );
};
